import React from 'react';
import './Team.css';

/**
 * Project progress component of the AnchorTech Solutions React Website.
 * Dynamic visualization of the contributing project member names, GitHub profile images, links to profiles, and roles.
 * @param {{name, responsibility, imageUrl, url}[]} formattedOrgMemberData API-fetched formatted project member data
 */
function Team({ formattedOrgMemberData }) {
    return (
        <>
            <h1 className='h1Team'>Team members</h1>
            <ul className='ulTeam'>
                {formattedOrgMemberData.map(member => (
                    <li key={member.name} className='liTeam'>
                        <div className='memberInfo'>
                            <a href={member.url} target="_blank" rel="noopener noreferrer" className='aTeam'>
                                <div className='memberName'>{member.name}</div>
                                <img src={member.imageUrl} alt={member.name} className='imgTeam' />
                            </a>
                            <ul className='memberResponsibility'>
                                {member.responsibility.split(',').map((role, index) => (
                                    <li key={index}>{role.trim()}</li>
                                ))}
                            </ul>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default Team;
